// TYPES

import { ReducerAction } from 'store/modules/types';
import { CadastrarCidadaoAutistaRequest, Types } from './types';

export function cadastrarCidadaoAutistaRequest(
	payload: CadastrarCidadaoAutistaRequest,
): ReducerAction {
	return {
		type: Types.CADASTRAR_CIDADAO_AUTISTA_REQUEST,
		payload,
	};
}

export function cadastrarCidadaoAutistaSuccess(payload: object): ReducerAction {
	return {
		type: Types.CADASTRAR_CIDADAO_AUTISTA_SUCCESS,
		payload,
	};
}

export function cadastrarCidadaoAutistaFailure(payload: object): ReducerAction {
	return {
		type: Types.CADASTRAR_CIDADAO_AUTISTA_FAILURE,
		payload,
	};
}

export function cadastrarCidadaoAutistaClear(): ReducerAction {
	return {
		type: Types.CADASTRAR_CIDADAO_AUTISTA_CLEAR,
		payload: null,
	};
}
